import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Select, Switch } from "antd";
import { useFormTcfVendor } from "../../../../../contexts/formTcfVendor.js";
import { useI18n } from "../../../../../contexts/i18n.js";
const FormTcfVendorFieldGeneralTerritorialScope = ()=>{
    const { __ } = useI18n();
    const { iso3166OneAlpha2, vendor: { additionalInformation } } = useFormTcfVendor();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Form.Item, {
                label: __("Territorial scope"),
                children: [
                    /*#__PURE__*/ _jsx(Select, {
                        mode: "multiple",
                        disabled: true,
                        value: additionalInformation?.territorialScope ? [
                            ...additionalInformation.territorialScope
                        ] : [],
                        children: Object.keys(iso3166OneAlpha2).map((code)=>/*#__PURE__*/ _jsx(Select.Option, {
                                value: code,
                                children: iso3166OneAlpha2[code]
                            }, code))
                    }),
                    /*#__PURE__*/ _jsx("p", {
                        className: "description",
                        children: __("The EU/EEA/EFTA/UK jurisdictions where the vendor operates in the context of its TCF registration. Note that this is different from the place of establishment.")
                    }),
                    /*#__PURE__*/ _jsx(Switch, {
                        checked: additionalInformation?.internationalTransfers,
                        disabled: true
                    }),
                    /*#__PURE__*/ _jsxs("span", {
                        children: [
                            "\xa0\xa0",
                            __("This vendor transfers data outside EU/EEA")
                        ]
                    })
                ]
            }),
            additionalInformation?.internationalTransfers && /*#__PURE__*/ _jsx(Form.Item, {
                label: __("Transfer mechanism"),
                children: /*#__PURE__*/ _jsxs(Select, {
                    mode: "multiple",
                    disabled: true,
                    value: additionalInformation?.transferMechanisms ? [
                        ...additionalInformation.transferMechanisms
                    ] : [],
                    children: [
                        /*#__PURE__*/ _jsx(Select.Option, {
                            value: "Adequacy decision",
                            children: __("Adequacy decision")
                        }),
                        /*#__PURE__*/ _jsx(Select.Option, {
                            value: "SCCs",
                            children: __("Standard contractual clauses")
                        }),
                        /*#__PURE__*/ _jsx(Select.Option, {
                            value: "BCRs",
                            children: __("Binding corporate rules")
                        }),
                        /*#__PURE__*/ _jsx(Select.Option, {
                            value: "Other",
                            children: __("Other")
                        })
                    ]
                })
            })
        ]
    });
};
export { FormTcfVendorFieldGeneralTerritorialScope };
